import { EventEmitter } from 'events';

export class NewDateTrigger extends EventEmitter {
  constructor(triggeredDateTime: Date) {
    super();
    this.scheduleNewDateEvent(triggeredDateTime);
  }

  private scheduleNewDateEvent(currentDate: Date) {
    const nextMidnight = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 1,
      0, 0, 0, 0
    );

    const delay = nextMidnight.getTime() - currentDate.getTime();

    setTimeout(() => {
      this.emit('new-date');      
      this.scheduleNewDateEvent(new Date()); // reschedule for next day
    }, delay);
  }
}
